//#region types
import { AuthEnums } from "models/enums";
import { WintSuperkollAPIModel as ApiModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
import { KeyValue } from "models/utilTypes/keyValue";
//#endregion
import useAPIClientHelper from "./useAPIClientHelper";
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

function useProfileRoutineService() {
  const { apiClientInstance } = useAPIClientHelper();

  const updateProfileRoutine = (profileRoutine: ApiModel.ProfileRoutine) => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .ProfileRoutineClient.Put(profileRoutine.id, profileRoutine)
      .then();
  };

  const getFrequencyName = (frequency?: ApiModel.DateRepetition) => {
    if (!frequency) return "";
    return LocalizationHelperInstance.getTranslatedEnumValue("ProfileRoutine.Frequency", frequency);
  };

  const getTodoState = (state?: ApiModel.ProfileRoutineState) => {
    return LocalizationHelperInstance.getTranslatedEnumValue("ProfileRoutine.State", state);
  };

  const getTodoStateLabelClass = (state: ApiModel.ProfileRoutineState) => {
    if (state === ApiModel.ProfileRoutineState.Started) {
      return cssExports.greenTag;
    } else if (state === ApiModel.ProfileRoutineState.Done) {
      return cssExports.blueTag;
    } else {
      return cssExports.yellowTag;
    }
  };

  const getDetailsList = (profileRoutine: ApiModel.ProfileRoutine) => {
    const details = [
      new KeyValue(
        LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.StartDate),
        LocalizationHelperInstance.getFormattedDate(profileRoutine.startDate)
      ),
      new KeyValue(
        LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Date),
        LocalizationHelperInstance.getFormattedDate(profileRoutine.routineDate)
      ),
    ];

    return details;
  };

  const onClear = (profileRoutine: ApiModel.ProfileRoutine) => {
    profileRoutine.state = ApiModel.ProfileRoutineState.Done;
    return updateProfileRoutine(profileRoutine);
  };
  return { updateProfileRoutine, getFrequencyName, getTodoState, getTodoStateLabelClass, getDetailsList, onClear };
}

export default useProfileRoutineService;
